import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class CustomFieldOption extends DomainObject {
  @observable value;
}

export default CustomFieldOption;
